interface ErrorWithCode {
    code: number;
}

export function isErrorWithCode(error: unknown): error is ErrorWithCode {
    return Object.keys(error as ErrorWithCode).indexOf('code') > -1;
}
